module.exports = __webpack_public_path__ + "static/media/unico-materiais-construcao.cd96e572.png";